import React from "react";
import useMobile from "views/components/Editor/mobile/useMobile";

const MOBILE_MIN_TOUCH_TARGET = 24;

const Table2CellDragHandle = ({
  position,
  handleResizeMouseDown,
  zoom,
  cellHeight,
  cellWidth,
  isExtremeBorder
}) => {
  const isMobile = useMobile();
  const isColumnResizeHandle = ["left", "right"].includes(position);

  // Much smaller handle width for left/right, slightly larger for top/bottom
  // Left/right handles are more intrusive so make them smaller
  const handlePercentage = isColumnResizeHandle ? 0.015 : 0.03; // 1.5% for columns, 3% for rows
  const maxHandleSize = isColumnResizeHandle ? 8 : 12; // 8px max for columns, 12px for rows

  const handleWidth =
    handlePercentage * (isColumnResizeHandle ? cellWidth : cellHeight);
  let scaledWidth = Math.min(handleWidth, maxHandleSize) * zoom;

  // Ensure minimum handle size for usability, but smaller for columns
  const minSize = isColumnResizeHandle ? 3 : 4;
  scaledWidth = Math.max(scaledWidth, minSize);

  // Position handles to overlap the border as originally intended
  let resizeHandleOrigin = "-1px";

  // For extreme borders, adjust positioning to overlap properly
  if (isExtremeBorder) {
    scaledWidth = scaledWidth * (isColumnResizeHandle ? 1.2 : 1.5); // Less increase for columns
    resizeHandleOrigin = `-${scaledWidth / 2}px`;
  }

  // On mobile, ensure minimum touch target size for usability
  if (isMobile) {
    scaledWidth = Math.max(scaledWidth, MOBILE_MIN_TOUCH_TARGET);
    resizeHandleOrigin = `-${scaledWidth / 2}px`;
  }

  return (
    <div
      style={{
        [position]: resizeHandleOrigin,
        height: isColumnResizeHandle ? "100%" : `${scaledWidth}px`,
        width: isColumnResizeHandle ? `${scaledWidth}px` : "100%",
        position: "absolute",
        zIndex: 1000,
        cursor: isColumnResizeHandle ? "ew-resize" : "ns-resize",
        touchAction: "none"
      }}
      data-border={position}
      onMouseDown={handleResizeMouseDown}
      onTouchStart={event => {
        event.stopPropagation();
        handleResizeMouseDown(event);
      }}
    />
  );
};

export { Table2CellDragHandle };
export default Table2CellDragHandle;
